module.exports = __webpack_public_path__ + "static/media/bg_for_dost_chatting.3ad0332f.jpg";